export function addFlashlightEffect(element: HTMLElement): void {
    element.addEventListener("mousemove", (event: MouseEvent) => {
        const rect = element.getBoundingClientRect()
        element.style.setProperty("--fx", `${event.clientX - rect.left}px`)
        element.style.setProperty("--fy", `${event.clientY - rect.top}px`)
    })
    element.addEventListener("mouseleave", () => {
        element.style.setProperty("--fx", "-9999px")
        element.style.setProperty("--fy", "-9999px")
    })
}
